<template>

</template>
<script>
import io from 'socket.io-client'
import Cookie from "../../common/cookie";
import { socketUrl } from "../../common/socket";
export default {
    data(){
        return {
            socket:null,
            lan:Cookie.get("lang")
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        //弹出信息
        init(){
            console.log('-------公告消息-----init--------')
            this.socket = new WebSocket(socketUrl());
            this.socket.onmessage = (e) => {
                try{
                    console.log('-------收到消息-------------')
                     var data = JSON.parse(e.data);
                     if(data.type == "allNotice"){
                         if(this.lan == data.lan){
                             this.show(data.msg);
                             console.log("弹出公告==" + data.msg);
                         }
                     }
                }catch(e){
                    console.log(e);
                }
            };
            // this.socket = io("https://106.75.16.14:8283", {
            //     path:"/",
            //     transports: ['websocket'],
            //     query: {
            //         user: 'cde'
            //     }
            // });

            // this.socket.on('connect', (data) => {
            //     this.socket.emit("history",{user:'085792'});
            // });

            // this.socket.on('msg', (data) => {
            //     console.log(this.lan,data.lan_state);

            //     if(this.lan == data.lan_state){
            //         this.show(data.msg);
            //     }
            // });
        },
        show(message){
            this.$notify({
                title: this.lan=="ch"?'公告':'Bulletin Board',
                dangerouslyUseHTMLString: true,
                message: message,
                duration: 0,
                position: 'bottom-right'
            });
        }
    },
    watch:{

    }
}
</script>

<style>
.el-notification {
  border: 1px solid #acd1ff;
  border-radius: 5px;
}
</style>
